import axios from '../utils/axios'

export function weblogin(params) {
    return axios.post('/weblogin', params)
}

export function reqestDevice(params) {
    return axios.post('/device', params)
}

export function reqestUpdateRole(params) {
    return axios.post('/role', params )
}

export function reportRole(params) {
    return axios.post('/feedback', params )
}